import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Paper} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  alertPopup: {
    fontSize: 11,
    color: '#1054AD',
    fontWeight: 600,
    backgroundColor: 'white',
    zIndex: 1,
    width: '260px',
    position: 'absolute',
    textAlign: 'justify',
    padding: '5px',
    whiteSpace: ' pre-wrap',
    fontFamily: 'articulat-cf, sans-serif !important',
  },
  close: {
    padding: theme.spacing(0.5),
    fontSize: 10,
    fontWeight: 600,
  },
}));

export default function ConsecutiveSnackbars({message, touched, setFieldTouched, name}) {
  useEffect(() => {
    setTimeout(() => {
      setFieldTouched(name, false);
    }, 5000);
  }, [touched[name]]);

  const classes = useStyles();
  return (
    <div>
      <Paper className={classes.alertPopup}>
        {message}
        {/* <IconButton
          aria-label="close"
          color="inherit"
          className={classes.close}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton> */}
      </Paper>
    </div>
  );
}
